import { augmentCarbarUrl } from '../utils/api.js'

export const $fetchForApi = (url, options) => {
	const accessToken = apiAccessToken()

	let fetchOptions = { ...options }

	fetchOptions.headers = {
		...fetchOptions.headers,
		Accept: 'application/json',
		Authorization: `Bearer ${accessToken}`,
	}

	let env = null

	if (import.meta.server) {
		fetchOptions.baseURL = process.env.NUXT_PUBLIC_API_URL
		env = process.env.NUXT_PUBLIC_NODE_ENV
	} else {
		const runtimeConfig = useRuntimeConfig()
		fetchOptions.baseURL = runtimeConfig.public.API_URL
		env = runtimeConfig.public.NODE_ENV
	}

	return $fetch(augmentCarbarUrl(url, env), fetchOptions)
}
